import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 1000 * 60, retry: false } },
});

// comment this out to test matomo locally if needed.
const isLocalhost = window.location.hostname === 'localhost';

const matomoInstance = createInstance({
  siteId: parseInt(import.meta.env.VITE_MATOMO_SITEID),
  urlBase: import.meta.env.VITE_MATOMO_BASEURL,
  disabled: isLocalhost,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* @ts-expect-error - MatomoProvider types don't properly support children in v0.5.1 */}
      <MatomoProvider value={matomoInstance}>
        <App />
      </MatomoProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);